export const RECTANGLE_TRANSFORM = 'RectangleWarp';
export const PERSPECTIVE_TRANSFORM = 'PerspectiveWarp';
export const TUBE_TRANSFORM = 'TubeWarp';
export const PLACEMENT_TRANSFORM = 'PlacementWarp';
export const SMOOTH_TRANSFORM = 'SmoothWarp';
export const TEXTURE_TRANSFORM = 'TextureWarp';
